import { type TransformationJob } from 'job-lib/types/Job'

export const createEmptyTransformationJob = (): TransformationJob => {
  return {
    revision: 0,
    components: {},
    connectors: {}
  }
}
